// extracted by mini-css-extract-plugin
module.exports = {"payment-mode-warning":"payment-mode-warning__FLWqP"};